module.exports = __webpack_public_path__ + "img/caia_03.8a953e16.png";